import { Box, Typography } from "@mui/material";
import React, { useState } from "react";
import { useEffect } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { getGroupsActive } from "../api/group";
import { getMyInformation, putSetImageGroup } from "../api/signin";
import groupPic from "../assets/image/groupPic.png";
import NotificationIcon from "../assets/SVG/notificationIcon";
import Acconts from "../pages/acconts";
import Dashboard from "../pages/dashboard";
import AccontsTrip from "../pages/leaderGroup/accontsTrip";
import DashboardTrip from "../pages/leaderGroup/dashboard";
import TripsPage from "../pages/leaderGroup/tripsPage";
import Project from "../pages/project";
import DashboardArea from "./areaManager/dashboardArea";
import CardTitleGroup from "./cardTitleGroup";
import DashboardGroup from "./dashboardGroup";
import Logoutpop from "./logoutpop";
import ViewProfile from "./profile/viewProfile";
import imageShowProf from "../assets/image/imageShowProf.png";
import NotePage from "../pages/leaderGroup/notePage";
import { getAllRegions } from "../api/area";
import Reception from "./areaManager/sidebarArea/reception/reception";
import AdultEducation from "./areaManager/sidebarArea/education/adultEducation";
import ChildrenEducation from "./areaManager/sidebarArea/education/childrenEducation";
import Secretaries from "./areaManager/sidebarArea/secretaries/secretaries";
import Insurer from "./areaManager/sidebarArea/insurer/insurer";
import Qarbal from "./areaManager/sidebarArea/qarbal/qarbal";
import Drug from "../pages/leaderGroup/drug";
import DrugTableArea from "./areaManager/sidebarArea/drug/drugTable";
import Equipment from "../pages/leaderGroup/equipment";
import Erja from "../pages/leaderGroup/erja";

export default function Index({ digest, data, setData, setSidebarAreaData }) {
  const [openPopoverLogout, setOpenPopoverLogout] = useState();
  const [openProfilePop, setOpenProfilePop] = useState(false);
  const [dataMyInfo, setDataMyInfo] = useState();
  const [image, setImage] = useState();
  const [dataGroupsActive, setDataGroupsActive] = useState();
  const [avatarPic, setAvatarPic] = useState();
  // const [data, setData] = useState();
  // useEffect(() => {
  //   getGroupsActive()
  //     .then((x) => console.log(x))
  //     .catch((z) => console.log(z));
  // }, []);
  useEffect(() => {
    if (digest) {
      getMyInformation()
        .then((x) => {
          setDataMyInfo(x);
          setImage(x.pic);
        })
        .catch((z) => console.log(z));
      if (digest?.role === "ADMIN") {
        getGroupsActive()
          .then((x) => setDataGroupsActive(x))
          .catch(() => {});
      }
    }
  }, [digest]);

  // console.log(dataGroupsActive[0]);
  return (
    <>
      <ViewProfile
        setAvatarPic={setAvatarPic}
        role={
          digest?.role === "ADMIN"
            ? "مسئول کل"
            : digest?.role === "GROUP"
            ? "مسئول گروه"
            : digest?.hasActiveRegion === true
            ? "مسئول منطقه"
            : "جهادگر"
        }
        image={image}
        setImage={setImage}
        setDataMyInfo={setDataMyInfo}
        dataMyInfo={dataMyInfo}
        setShow={setOpenProfilePop}
        show={openProfilePop === false ? false : true}
        groupInfo={openProfilePop === "group" ? true : false}
      />
      <Logoutpop
        groupInfo={digest?.role === "GROUP" ? true : false}
        setOpenProfilePop={setOpenProfilePop}
        openPopover={openPopoverLogout}
        setOpenPopover={setOpenPopoverLogout}
      />
      <Box padding={"40px"} width="80%" sx={{ overflow: "auto" }}>
        <Box
          display={"flex"}
          width="100%"
          justifyContent="space-between"
          alignItems="center"
        >
          {dataGroupsActive ? (
            <CardTitleGroup
              pic={dataGroupsActive[0]?.user?.pic}
              titr={dataGroupsActive[0]?.areas[0]?.name}
              name={dataGroupsActive[0]?.name}
            />
          ) : (
            <CardTitleGroup
              pic={groupPic}
              titr={"علی رضایی"}
              name={"گروه جهادی کاظمی آشتیانی"}
            />
          )}
          <Box display={"flex"} alignItems="center">
            <Box
              bgcolor="white"
              padding="10px 15px"
              ml="15px"
              borderRadius="50%"
            >
              <NotificationIcon />
            </Box>
            <CardTitleGroup
              pic={avatarPic || image}
              titr={
                digest?.role === "ADMIN"
                  ? "مسئول کل"
                  : digest?.role === "GROUP"
                  ? "مسئول گروه"
                  : digest?.hasActiveRegion === true
                  ? "مسئول منطقه"
                  : "جهادگر"
              }
              profile
              name={digest?.name}
              onClick={(e) => setOpenPopoverLogout(e.currentTarget)}
            />
          </Box>
        </Box>
        <Routes>
          {/* <Route path="/login" element={<Box>login</Box>} /> */}
          <Route element={<Dashboard />} />
          <Route
            path="/"
            element={
              digest?.role === "JAHADI" ? (
                <DashboardArea
                  setSidebarAreaData={setSidebarAreaData}
                  role={digest}
                  data={data}
                  setData={setData}
                />
              ) : digest?.role === "GROUP" ? (
                <DashboardTrip data={dataMyInfo} />
              ) : (
                <NotePage />
              )
            }
          />

          <Route path="/groups" element={<Dashboard />} />
          <Route path="/projects" element={<Project />} />
          <Route path="/acconts" element={<Acconts />} />

          {/* <Route
            path="/dashboard_trip"
            element={<DashboardTrip data={dataMyInfo} />}
          /> */}
          <Route path="/trips" element={<TripsPage />} />
          <Route
            path="/acconts_trip"
            element={<AccontsTrip data={dataMyInfo} />}
          />
          <Route path="/drug" element={<Drug data={dataMyInfo} />} />
          <Route path="/equipment" element={<Equipment data={dataMyInfo} />} />
          <Route path="/erja" element={<Erja dataArea={data} />} />

          <Route path="/reception" element={<Reception dataArea={data} />} />
          <Route
            path="/education"
            element={<AdultEducation dataArea={data} />}
          />
          <Route
            path="/childrenEducation"
            element={<ChildrenEducation dataArea={data} />}
          />
          <Route
            path="/secretaries"
            element={<Secretaries dataArea={data} />}
          />
          <Route path="/insurer" element={<Insurer dataArea={data} />} />
          <Route path="/qarbal" element={<Qarbal dataArea={data} />} />
          <Route path="/module" element={<Qarbal dataArea={data} />} />
          <Route
            path="/drugTable"
            element={<DrugTableArea dataArea={data} />}
          />
          <Route
            path="/drugWarehouse"
            element={<Drug notGroup dataArea={data} />}
          />
          <Route
            path="/equipmentTable"
            element={<DrugTableArea equipment dataArea={data} />}
          />
          <Route
            path="/equipmentWarehouse"
            element={<Equipment notGroup equipment dataArea={data} />}
          />
          <Route path="/erjaTable" element={<Erja notGroup dataArea={data} />} />
        </Routes>
      </Box>
    </>
  );
}
